module.exports = __webpack_public_path__ + "static/media/App_Store.097a1b32.png";